import { h } from "./../../utils/createElement";
import { __assign } from "tslib";
import * as React from 'react';
export function renderChildren(props, checkedValues, handleSingleChange, Component, itemStyle) {
    var children = props.children;
    var options = props.options || [];
    var disabled = props.disabled;
    var style = __assign({ paddingBottom: 22 }, itemStyle);
    if (options.length) {
        return options.map(function (option, index) {
            if (typeof option === 'string') {
                return (h(Component, { key: index, value: option, onChange: handleSingleChange, checked: checkedValues.indexOf(option) !== -1, disabled: disabled, style: __assign({}, style) }, option));
            }
            else {
                return (h(Component, __assign({}, option, { key: index, value: option.value, onChange: handleSingleChange, checked: checkedValues.indexOf(option.value) !== -1, disabled: option.disabled || disabled, style: __assign(__assign({}, style), option.style) }), option.label));
            }
        });
    }
    return React.Children.map(children, function (child) {
        return React.cloneElement(child, {
            checked: checkedValues.indexOf(child.props.value) !== -1,
            onChange: handleSingleChange,
            disabled: child.props.disabled || disabled,
            style: __assign(__assign({}, style), child.props.style)
        });
    });
}
